import React, { useState } from "react";
import styles from "./WorkspaceSection.module.css";
import ProfileModalTemplate from "../../ProfileModalTemplate/ProfileModalTemplate";
import EditableInput from "../../AccountSettings/EditableInput/EditableInput";
import ImageEmpty from "../../../assets/ImageEmpty.svg";
import { useTranslation } from "react-i18next";
import Button from "../../Button/Button";
import { useSelector } from "react-redux";

const WorkspaceSection = ({ setSelectedOption }) => {

  const [t] = useTranslation("accountSetting");
  const [workspaceData, setWorkspaceData] = useState({});
	const { user } = useSelector((state) => state.user)


  const handleChangeImage = (key, value) => {
    setWorkspaceData((prev) => ({ ...prev, [key]: value }));
  };

  const handleChange = ({ name, newValue }) => {
    const updatedData = { ...workspaceData, [name]: newValue };
    setWorkspaceData(updatedData);
  };

  
 

  return (
    <div>
      <div className={styles.workspaceSectionLabel}>
        <ProfileModalTemplate
          image={workspaceData?.image}
          handleContactData={handleChangeImage}
          id={workspaceData?._id}
          sticky={true}
          customStyle={{
            width: "80px",
            height: "80px",
            borderRadius: "10px",
          }}
          camStyles={{
            padding: "2px",
          }}
        />
        {workspaceData?.workspace}
        <EditableInput
          placeholder={t("unknow")}
          label={t("workspace")}
          value={workspaceData?.name}
          name="name"
          onSave={handleChange}
          oneRow={true}
          customStyles={styles.noPadding}
        />
      </div>

      <div className={styles.workspaceSectionLabel}>
        <p>{t("access")}</p>
        <div className={styles.accessInfo}>
          <div>
            <p>John Doe</p>
            <div>
              <div className={styles.access}>
                <span className={styles.accessType}>{t("fullAccess")}</span>
                <span className={styles.rol}>Admin</span>
              </div>
            </div>
          </div>

          <img src={ImageEmpty} alt="" />
        </div>
      </div>

      <div className={styles.workspaceSectionLabel}>
        <div>
          <p>{t("team")}</p>
          <span className={styles.descSection}>50 {t("access")}</span>
        </div>

        <Button
          type="white"
          headerStyle={{ borderRadius: "999px" }}
          action={() => setSelectedOption(1)}
        >
          {t("manage")}
        </Button>
      </div>

      <div className={styles.workspaceSectionLabel}>
        <p>{t("creationDate")}</p>

        <span className={styles.descSection}>
          {new Date().toLocaleString("en-US", {
            day: "numeric",
            month: "long",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            hour12: true, 
          })}
        </span>
      </div>

      

      <div className={styles.workspaceSectionLabel}>
  <div >
    <p>{t("spendingLimit")}</p>
    <span className={styles.descSection}>
      {(workspaceData.spendingLimit || 0).toFixed(2)}€ {t("spent")}
    </span>
  </div>

  <div className={styles.spendingControls}>
    <Button
    headerStyle={{width:"30px",height:"30px",color:"#808080",fontWeight:"bold",borderRadius:"8px"}}
    type="border"
      action={() =>
        setWorkspaceData((prev) => ({
          ...prev,
          spendingLimit: Math.max(0, (prev.spendingLimit || 0) - 1),
        }))
      }
    >
      -
    </Button>

    <div className={styles.inputContainer}>
      <input
        type="number"
        value={workspaceData.spendingLimit || 0}
        onChange={(e) => {
          const value = parseInt(e.target.value, 10);
          setWorkspaceData((prev) => ({
            ...prev,
            spendingLimit: isNaN(value) ? 0 : value,
          }));
        }}
        min={0}
      />
      <span className={styles.descSection}>{t("accountMaximum")} {user?.maxAccount}</span>
    </div>

    <Button
    headerStyle={{width:"30px",height:"30px",color:"#808080",fontWeight:"bold",borderRadius:"8px"}}
    type="border"
      action={() =>
        setWorkspaceData((prev) => ({
          ...prev,
          spendingLimit: (prev.spendingLimit || 0) + 1,
        }))
      }
    >
      +
    </Button>
  </div>
</div>


<div className={styles.workspaceSectionLabel}>
        <p>{t("deleteWorkshop")}</p>

     <Button type="discard" headerStyle={{borderRadius:"999px"}}>{t('delete')}</Button>
      </div>



    </div>
  );
};

export default WorkspaceSection;
